import { useEffect, useState } from "react";
import InputReadMassiveOrders from "./inputReadMassiveOrders";
import { mapDispatchToProps, mapStateToProps } from "./storeProps";
import { connect } from "react-redux";
import { TableReadMassiveOrders } from "./tableReadMassiveOrders";

const TabReadMassiveOrders = ({
  bulkOrdersRead,
  reduxReadMassiveOrders,
  reduxDownloadBulkOrdersCSV,
  reduxResetBulkOrdersReader,
}) => {
  const [currentValuesSearched, setCurrentValuesSearched] = useState([]);
  const [page, setPage] = useState(1);

  const handleSubmitSearchOrders = (values) => {
    if (!values?.length) return;
    reduxReadMassiveOrders?.({ guidesList: values });
    setCurrentValuesSearched(values);
  };

  const handleClearResultsBulkOrders = () => {
    setCurrentValuesSearched([]);
    reduxResetBulkOrdersReader?.();
  };

  const handleDownloadBulkOrdersCsv = () => {
    if (!currentValuesSearched?.length) return;
    reduxDownloadBulkOrdersCSV?.({ guidesList: currentValuesSearched });
  };

  const foundOrdersCount = bulkOrdersRead?.foundOrders?.length;
  const hasDataToShow = foundOrdersCount > 0;

  useEffect(() => {
    if (!currentValuesSearched?.length) return;

    reduxReadMassiveOrders?.({ guidesList: currentValuesSearched, page: page });
  }, [page]);

  return (
    <div className="row card shadow mt-4 p-4">
      <div className="d-sm-flex align-items-center mb-1 gap-1">
        <InputReadMassiveOrders onSubmit={handleSubmitSearchOrders} />
        {hasDataToShow && (
          <>
            <button
              className="btn btn-primary"
              type="button"
              onClick={handleClearResultsBulkOrders}
            >
              Limpiar
            </button>
            <button
              className="btn btn-warning btn-circle"
              type="button"
              onClick={handleDownloadBulkOrdersCsv}
            >
              <i className="fas fa-download fa-sm"></i>
            </button>
          </>
        )}
      </div>
      {hasDataToShow && (
        <TableReadMassiveOrders {...bulkOrdersRead} onChangePage={setPage} />
      )}
    </div>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TabReadMassiveOrders);
